import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { SupervisionMessage } from './types';

/**
 * «Até onde eu li» das orientações da supervisão, por conversa — conveniência por
 * navegador (localStorage), como o rascunho do composer. Não é dado do produto:
 * perder isto só faz o contador voltar a contar tudo como novo.
 */
interface SupervisionSeenState {
  seen: Record<string, string>;
  markSeen: (conversationId: string, lastTimestamp: string) => void;
}

export const useSupervisionSeenStore = create<SupervisionSeenState>()(
  persist(
    (set) => ({
      seen: {},
      markSeen: (conversationId, lastTimestamp) =>
        set((s) => ({ seen: { ...s.seen, [conversationId]: lastTimestamp } })),
    }),
    { name: 'lume:supervision-seen', storage: createJSONStorage(() => localStorage) },
  ),
);

/** Quantas orientações chegaram DEPOIS da última lida. Sem marca ⇒ todas são novas. */
export function countUnread(
  messages: readonly SupervisionMessage[],
  lastSeen: string | undefined,
): number {
  if (lastSeen === undefined) return messages.length;
  return messages.filter((m) => m.timestamp > lastSeen).length;
}
